import { Component } from '@angular/core';
import { FamilyMemberType } from 'src/app/_enums/family-member-type.enum';
import { InsuranceType } from 'src/app/_enums/insurance-type.enum';
import { normalizeChangeReason } from 'src/app/_enums/lead-change-reason.enum';
import { User } from 'src/app/_types/auth.types';
import { CustomerProfilePanelComponent } from 'src/app/shared/components/customer-profile-panel/customer-profile-panel.component';

import { TaskDetailsService } from '../../task-details.service';

/**
 * The flow's « Informations du preneur d'assurance »: the shared panel, fed
 * from the task-details mediator like every other section of that modal.
 */
@Component({
  selector: 'app-task-user-profile-info',
  standalone: true,
  imports: [CustomerProfilePanelComponent],
  template: `
    <app-customer-profile-panel
      [userProfile]="userProfile"
      [familyMemberName]="familyMemberName"
      [relation]="relation"
      [insuranceType]="insuranceType"
      [changeReasons]="changeReasons"
    />
  `,
  styles: `
    :host {
      display: block;
      width: 100%;
    }
  `,
})
export class TaskUserProfileInfoComponent {
  constructor(private readonly taskDetailsService: TaskDetailsService) {}

  protected get userProfile(): User | null {
    return this.taskDetailsService.state.userProfile;
  }

  protected get familyMemberName(): string | null {
    return this.taskDetailsService.state.familyMemberName;
  }

  protected get relation(): FamilyMemberType | null {
    return this.taskDetailsService.state.relation;
  }

  protected get insuranceType(): InsuranceType | null {
    return this.taskDetailsService.state.insuranceType;
  }

  /** The lead's reasons when it has any, else the policy's. */
  protected get changeReasons(): string[] {
    const leadReasons = normalizeChangeReason(
      this.taskDetailsService.state.lead?.changeReason
    );
    if (leadReasons.length) {
      return leadReasons;
    }

    return normalizeChangeReason(
      this.taskDetailsService.state.policy?.changeReason
    );
  }
}
